export default "__VITE_ASSET__Py_6M1CL__"